import { CompendiumSelector } from "../app/CompendiumSelector.js";
import CONSTANTS from "../constants.js";
import utils from "../utils.js";

async function resetSettings() {
  for (const [name, data] of Object.entries(CONSTANTS.GET_DEFAULT_SETTINGS())) {
    // eslint-disable-next-line no-await-in-loop
    await game.settings.set(CONSTANTS.MODULE_NAME, name, data.default);
  }
  window.location.reload();
}

class ResetSettingsDialog extends FormApplication {
  constructor(...args) {
    super(...args);
    // eslint-disable-next-line no-constructor-return
    return new Dialog({
      title: game.i18n.localize(`${CONSTANTS.FLAG_NAME}.Dialogs.ResetSettings.Title`),
      content: `<p class="${CONSTANTS.FLAG_NAME}-dialog-important">${game.i18n.localize(
        `${CONSTANTS.FLAG_NAME}.Dialogs.ResetSettings.Content`,
      )}</p>`,
      buttons: {
        confirm: {
          icon: '<i class="fas fa-check"></i>',
          label: game.i18n.localize(`${CONSTANTS.FLAG_NAME}.Dialogs.ResetSettings.Confirm`),
          callback: () => {
            resetSettings();
          },
        },
        cancel: {
          icon: '<i class="fas fa-times"></i>',
          label: game.i18n.localize(`${CONSTANTS.FLAG_NAME}.Dialogs.ResetSettings.Cancel`),
        },
      },
      default: "cancel",
    });
  }
}

export async function processActiveGM() {
  // determine if this user is the active gm/first active in current session
  if (game.user.isGM) {
    const currentGMUser = game.users.get(utils.setting("ACTIVE_GM"));
    if ((currentGMUser && !currentGMUser.active) || !currentGMUser) {
      await utils.updateSetting("ACTIVE_GM", game.user.id);
    }
  }
}

export function registerSettings() {
  game.settings.registerMenu(CONSTANTS.MODULE_NAME, "resetToDefaults", {
    name: `${CONSTANTS.FLAG_NAME}.Settings.Reset.Title`,
    label: `${CONSTANTS.FLAG_NAME}.Settings.Reset.Label`,
    hint: `${CONSTANTS.FLAG_NAME}.Settings.Reset.Hint`,
    icon: "fas fa-refresh",
    type: ResetSettingsDialog,
    restricted: true,
  });

  for (const [name, data] of Object.entries(CONSTANTS.GET_DEFAULT_SETTINGS())) {
    game.settings.register(CONSTANTS.MODULE_NAME, name, data);
  }

  game.settings.registerMenu(CONSTANTS.MODULE_NAME, "selectCustomCompendiums", {
    name: `${CONSTANTS.FLAG_NAME}.Settings.UseCustomCompendiumMappings.Title`,
    label: `${CONSTANTS.FLAG_NAME}.Settings.UseCustomCompendiumMappings.Label`,
    hint: `${CONSTANTS.FLAG_NAME}.Settings.UseCustomCompendiumMappings.Hint`,
    icon: "fas fa-book",
    type: CompendiumSelector,
    restricted: true,
  });

}
